import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import InlineLoader from "@Shared/components/general/inline-loader.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import { computed, defineComponent, ref, toRefs } from "@vue/composition-api";
import TextSection from "@Shared/components/sections/text-section.vue";
import SelectSection from "@Shared/components/sections/select-section.vue";
import DateSection from "@Shared/components/sections/date-section.vue";
import Field from "@Shared/components/sections/field.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { useI18n } from "vue-i18n-composable";
import DecimalInput from "@Shared/components/inputs/decimal-input.vue";
import { v4 as uuidv4 } from "uuid";
import moment from "moment";
export default defineComponent({
  name: "CommissionFee",
  components: {
    TextSection,
    SelectSection,
    DateSection,
    Field,
    InlinePrompt,
    InlineLoader,
    MaterialInput,
    DecimalInput
  },
  props: {
    fee: {
      type: Object,
      required: true
    },
    fundedAmount: {
      type: [String, Number],
      default: 0
    },
    expandedGrid: {
      type: Boolean,
      default: false
    },
    saving: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const {
      fee,
      fundedAmount
    } = toRefs(props);
    const {
      t
    } = useI18n();
    const id = uuidv4();
    const fundsReceivedEndDate = ref(moment().add(1, "days").format());
    const computedFeeType = computed({
      get() {
        return fee.value.type;
      },
      set(value) {
        emit("change", _objectSpread(_objectSpread({}, fee.value), {}, {
          type: value
        }));
      }
    });
    const computedBasisPoints = computed({
      get() {
        return fee.value.basisPoints;
      },
      set(value) {
        emit("change", _objectSpread(_objectSpread({}, fee.value), {}, {
          basisPoints: _parseFloat(value) || 0
        }));
      }
    });
    const feeHasBasisPoints = computed(() => !!computedBasisPoints.value);
    const computedAmount = computed({
      get() {
        const fundedAmountToUse = typeof fundedAmount.value === "string" ? _parseFloat(fundedAmount.value) : fundedAmount.value;
        return feeHasBasisPoints.value ? fundedAmountToUse * (computedBasisPoints.value / 10000) : fee.value.amount;
      },
      set(value) {
        emit("change", _objectSpread(_objectSpread({}, fee.value), {}, {
          amount: _parseFloat(value)
        }));
      }
    });
    const computedFundsReceived = computed({
      get() {
        return fee.value.fundsReceived;
      },
      set(value) {
        emit("change", _objectSpread(_objectSpread({}, fee.value), {}, {
          fundsReceived: value
        }));
      }
    });
    const computedDescription = computed({
      get() {
        return fee.value.description;
      },
      set(value) {
        emit("change", _objectSpread(_objectSpread({}, fee.value), {}, {
          description: value
        }));
      }
    });
    const showBasisPoints = computed(() => fee.value.commissionsFeeId !== "brokerageFee");
    const feeTypeOptions = ref([{
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.mortgageInsurance"),
      value: "mortgage-insurance"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.closingServices"),
      value: "closing-services"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.retroactiveFee"),
      value: "retroactive-fee"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.adjustments"),
      value: "adjustments"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.reverseFinderFee"),
      value: "reverse-finders-fee"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.referralFee"),
      value: "referral-fee"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.bonus"),
      value: "bonus"
    }, {
      label: t("direct-to-lender.commissions.fees.feeTypeOptions.other"),
      value: "other"
    }]);
    const handleRemove = () => {
      emit("remove");
    };
    const handleChangeBasisPoints = ({
      target
    }) => {
      computedBasisPoints.value = target.value;
    };
    return {
      id,
      computedFeeType,
      computedBasisPoints,
      computedAmount,
      computedFundsReceived,
      computedDescription,
      feeTypeOptions,
      feeHasBasisPoints,
      handleRemove,
      handleChangeBasisPoints,
      fundsReceivedEndDate,
      showBasisPoints
    };
  }
});